import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Content = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 350px;
  max-width: 90%;
  max-height: 90%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 3px 16px rgba(0, 0, 0, 0.17);
  outline: none;
  padding: 24px 30px;
  overflow: auto;
`;

export const Title = styled('div')`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  color: ${theme.palette.text.dark};
  gap: 8px;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 16px;

  > button {
    margin-top: -8px;
    margin-right: -10px;

    svg {
      width: 30px;
      height: 30px;
    }
  }
`;
